import { isEmptyList } from "../../utils/UtilityFunctions";

export const INITIAL_STATE = {
    isUseCaseLoading : true,
    useCaseData : [],
    isUseCaseError : false
}

export const USECASE_CONTENT_TYPE = {
    SUBHEAD : 1,
    PARA : 2,
    IMAGE : 3,
    UNORDER_LIST : 4,
    ORDER_LIST : 5,
    QUOTE : 6,
    FIGURE : 7,
    CUSTOM_LIST_CHALLENGE : 8,
    CUSTOM_LIST_SOLUTION : 9,
    CUSTOM_LIST_BENEFIT : 10
}

export const CONTENT_ALIGN = {
    LEFT : "L",
    RIGHT : "R", 
    JUSTIFY : "J"
}

export const USECASES_BREAKPOINT = [
    {
        width: 1,
        itemsToShow: 1,
        itemsToScroll: 1,
    },
    {
        width: 490,
        itemsToShow: 2,
        itemsToScroll: 2,
    },
    {
        width: 576,
        itemsToShow: 3,
        itemsToScroll: 3,
    },
    {
        width: 768,
        itemsToShow: 3,
        itemsToScroll: 3
    },
    {
        width: 992,
        itemsToShow: 4,
        itemsToScroll: 4
    }
]

export const getUseCaseFromData = ({data}) => {
    let useCaseData = [];
    if(data.hasOwnProperty("usecase_details") && !isEmptyList(data.usecase_details)){
        useCaseData = Object.assign([],data.usecase_details)
    }
    return {
        useCaseData
    }
}